import { render, staticRenderFns } from "./deleteNotice.vue?vue&type=template&id=3f90b34d"
import script from "./deleteNotice.vue?vue&type=script&lang=js"
export * from "./deleteNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports